<div class="desktop">
    @if (communitiesCount > 1) {
        <button [matMenuTriggerFor]="menu"
                mat-button>{{ selectedCommunity?.name || 'Select community' }}
        </button>
    }
</div>

@if (communitiesCount > 1) {
    <button [matMenuTriggerFor]="menu" class="tablet d-flex" mat-menu-item>
        <span>Communities</span>
    </button>
}

<mat-menu #menu="matMenu">
    @for (community of communities; track community) {
        <button (click)="selectOption(community.id)"
                [class.activeCommunityBtn]="community.id === selectedCommunity?.id"
                mat-menu-item>
            {{ community.name }}
        </button>
    }
</mat-menu>
